export default "__VITE_ASSET__c6t5pS4s__"